import { Buffer } from 'buffer/'
import { initI18n, initSentry } from 'daisy-v2-shared/src'
import ReactDOM from 'react-dom/client'

initI18n()

console.log(`ENV: ${process.env.REACT_APP_CLIENT_ENV}`)
window.Buffer = window.Buffer || Buffer
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// work around for fix Buffer init issue (same as platform bootstrap)
;(async () => {
  const app = await import('./App')

  root.render(<app.default />)
  initSentry()
})()
